export const formatPriceValue: any = (price, currency) =>
  new Intl.NumberFormat('en-GB', {
    minimumFractionDigits: 2,
    ...(currency ? { style: 'currency', currency } : {}),
  }).format(price);
